/**
 * Calculates the discount percentage given original price and discount price.
 * Handles edge cases like zero or negative prices safely.
 *
 * @param {number} originalPrice - The original price before discount
 * @param {number} discountPrice - The discount amount (not the discounted price)
 * @returns {number} - Discount percentage (integer)
 */

export const calculateDiscountPercentage = (originalPrice, discountPrice) => {
  if (originalPrice <= 0) return 0;
  const percent = (discountPrice / originalPrice) * 100;
  if (percent > Math.floor(percent) + 0.5) return Math.ceil(percent);
  else if (percent < Math.floor(percent) + 0.4) return Math.floor(percent);
  else return Math.round(percent);
};

/**
 * Calculates the final discounted price.
 *
 * @param {number} originalPrice - The original price before discount
 * @param {number} discountPrice - The discount amount
 * @returns {number} - Final price after discount (rounded up)
 */
export const calculateFinalPrice = (originalPrice, discountPrice) => {
  return Math.ceil(Math.max(originalPrice - discountPrice, 0));
};
